import type { UserCardProps } from '@bliks-io/ui';
import type { UserRef } from '@bliks-io/contracts';

export interface NudgeTarget {
  userId: string;
  name: string;
  processId: string;
  processName: string;
  stepId?: string;
}

/** Maps nullable contract fields to the optional shape UserCard expects. */
export function toUserCardProps(user: UserRef): UserCardProps['user'] {
  return {
    firstName: user.firstName,
    lastName: user.lastName,
    avatar: user.avatar ?? undefined,
    role: user.role ?? undefined,
    departmentAbbreviation: user.departmentAbbreviation ?? undefined
  };
}
